import React, { useRef, useEffect } from 'react';
import Select from 'react-select/async';
import { useField } from '@unform/core';
import customStyles, { theme } from './stylesSelect';

export default function AsyncSelect({ name, defaultValue, label, ...rest }) {
  const selectRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref) => {
        if (rest.isMulti) {
          if (!ref.select.state.value) {
            return [];
          }
          return ref.select.state.value.map((option) => option.value);
        }
        if (!ref.select.state.value) {
          return '';
        }
        return ref.select.state.value.value;
      },
      setValue: (ref, value) => {
        ref.select.state.value = value;
        ref.select.updater.enqueueForceUpdate(ref);
      },
    });
  }, [fieldName, registerField, rest.isMulti]);
  return (
    <div className="form-group">
      <label htmlFor={fieldName} className="form-label">
        {label}
      </label>
      <Select
        cacheOptions
        defaultValue={defaultValue}
        ref={selectRef}
        classNamePrefix="react-select"
        className={error && 'error'}
        styles={customStyles}
        theme={theme}
        defaultOptions
        placeholder="Digite para pesquisar"
        noOptionsMessage={() => 'Sem registros'}
        {...rest}
      />
      {error && <small className="error">{error}</small>}
    </div>
  );
}
